import React from 'react';
import slideSelectedImg from './slide-selected.svg';
import slideUnselectedImg from './slide-unselected.svg';
import * as routes from '../../constants/routes';

class WelcomeSlider extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      // Non-array props.children has a length
      // attribute:
      childCount: props.children.length,
      // Start at the first child:
      childIdx: 0,
    }

    // Attach event handlers to instance of the component
    // object.
    this.slideButton = this.slideButton.bind(this);
    this.setSlide = this.setSlide.bind(this);
    this.renderCurrentSlide = this.renderCurrentSlide.bind(this);
    this.renderSlideButtons = this.renderSlideButtons.bind(this);
  }

  // Assigned as a click-handler to slide buttons, and to
  // the div that holds the slides, so that just tapping the
  // div will advance the slides.
  setSlide(slideIdx, event) {
    // If one of the slider buttons is clicked, stop the
    // click event being picked up by the enclosing div
    // as well
    event.stopPropagation();

    // Make sure the slide index isn't larger than the
    // number of slides.
    if ( slideIdx >= this.props.children.length ) {
      return;
    }

    // Record our new slide indx value, causing a re-render
    this.setState({
      childIdx: slideIdx,
    })
  }

  // Renders a cicular button used to display a slide when clicked.
  slideButton(slideIdx, selected = false) {
    const sbStyle = {
      margin: '6px',
      cusror: 'pointer',
    };
    return (
      <img
        key={slideIdx}
        alt="slider"
        width="23px"
        height="23px"
        style={ sbStyle }
        src={ selected ? slideSelectedImg : slideUnselectedImg }
        onClick={ this.setSlide.bind(this, slideIdx) }
      />
    );
  }

  // Renders the set of buttons for controlling which slide is displayed:
  renderSlideButtons() {
    return (
      React.Children.toArray(this.props.children)
      .map((child, childIdx) => {
        return this.slideButton(
          childIdx,
          (childIdx === this.state.childIdx)
        );
      })
    );
  }

  // Renders current slide
  renderCurrentSlide() {
    return (
      React.Children.toArray(this.props.children)
      .filter( (child, childIdx) =>
        childIdx === this.state.childIdx
      )
    );
  }

  // For each of the child components present in props.children:
  //  Render the 'current' child (whatever state.childIdx is set to)
  //  Render a series of buttons that can be used to change the current slide.
  render() {
    const slideButtonsStyle = {
      textAlign: 'center',
    };
    return (
      <div onClick={ this.setSlide.bind(this, this.state.childIdx + 1) }>
        <div> { this.renderCurrentSlide() } </div>
        <div style={slideButtonsStyle}> { this.renderSlideButtons() } </div>
      </div>
    );
  }
}


export default WelcomeSlider;



// WEBPACK FOOTER //
// ./src/components/WelcomeSlider/index.js